import React from "react";
import { Activity, Database, HardDrive, RefreshCw, Server } from "lucide-react";

const TONE = {
    ok: {
        pill: "bg-emerald-500/15 border-emerald-500/30 text-emerald-300",
        dot: "bg-emerald-400",
    },
    warn: {
        pill: "bg-amber-500/15 border-amber-500/30 text-amber-200",
        dot: "bg-amber-400",
    },
    error: {
        pill: "bg-red-500/15 border-red-500/30 text-red-200",
        dot: "bg-red-400",
    },
};

function Item({ ok, label, detail, icon: Icon }) {
    return (
        <div
            className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border text-[11px] ${
                ok ? TONE.ok.pill : TONE.warn.pill
            }`}
            title={detail || label}
        >
            <Icon className="h-3.5 w-3.5 shrink-0" />
            <span>{label}</span>
            <span className={`h-1.5 w-1.5 rounded-full ${ok ? TONE.ok.dot : TONE.warn.dot}`} />
        </div>
    );
}

export default function SystemHealthBar({ health, loading, onRefresh }) {
    const tone = TONE[health?.status] || TONE.warn;
    const redisOk = !!health?.redis?.ok;
    const celeryOk = !!health?.celery?.ok;
    const backupOk = !!health?.mysql_backup?.ok;

    return (
        <div className="rounded-xl border border-white/[0.08] bg-[#0a1018]/70 px-3 py-2.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
            <div className="flex items-center gap-2 min-w-0">
                <span
                    className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md border text-[10px] uppercase tracking-wider ${tone.pill}`}
                >
                    <span className={`h-1.5 w-1.5 rounded-full ${tone.dot}`} />
                    Sistem {health?.status === "ok" ? "Sağlıklı" : health?.status === "warn" ? "Uyarı" : "Kontrol"}
                </span>
                {loading && !health ? (
                    <span className="text-[11px] text-slate-500">Kontrol ediliyor…</span>
                ) : null}
            </div>
            <div className="flex flex-wrap items-center gap-2">
                <Item
                    ok={redisOk}
                    label="Redis"
                    detail={health?.redis?.detail}
                    icon={Server}
                />
                <Item
                    ok={celeryOk}
                    label={`Celery${health?.celery?.count ? ` (${health.celery.count})` : ""}`}
                    detail={health?.celery?.detail}
                    icon={Activity}
                />
                <Item
                    ok={backupOk}
                    label="DB Yedek"
                    detail={
                        health?.mysql_backup?.file
                            ? `${health.mysql_backup.file} · ${health.mysql_backup.age_hours}sa`
                            : health?.mysql_backup?.detail
                    }
                    icon={Database}
                />
                <Item ok={!!health?.daphne?.ok} label="API" detail="Daphne" icon={HardDrive} />
                <button
                    type="button"
                    onClick={onRefresh}
                    className="inline-flex items-center gap-1 px-2 py-1 rounded-lg border border-white/10 text-[11px] text-slate-400 hover:text-[#F3E5AB] hover:border-[#D4AF37]/30"
                    title="Yenile"
                >
                    <RefreshCw className={`h-3.5 w-3.5 ${loading ? "animate-spin" : ""}`} />
                </button>
            </div>
        </div>
    );
}
